<template>
  <div class="library-panel">
    <SaveToLibraryButton
      :content-uuid="strategyUuid"
      :content-payload="{}"
      :user-uuid="userUuid"
      :action-permissions="actionPermissions.save"
      :enable-notes="true"
      @saved:start="setSaveStatus({ saving: true })"
      @saved:error="handleSaveError"
      @saved:success="handleSaveSuccess"
    />

    <transition name="fade">
      <alert
        type="success"
        class="action-alert text-center"
        :dismissible="true"
        @dismissed="setSaveStatus({ savedStrategyUuid: '', savedStudentName: '' })"
        :duration="5000"
        v-if="saveToLibraryStatus.savedStrategyUuid"
      >
        Saved to <span class="fs-block">{{ saveToLibraryStatus.savedStudentName }}</span
        >!
        <router-link
          :to="{
            name: 'SavedStrategyPage',
            params: { uuid: saveToLibraryStatus.savedStrategyUuid },
          }"
        >View saved strategy page</router-link
        >
      </alert>
    </transition>
    <transition name="fade">
      <alert
        type="danger"
        class="action-alert text-center"
        :dismissible="true"
        @dismissed="setSaveStatus({ saveError: '' })"
        :duration="5000"
        v-if="saveToLibraryStatus.saveError"
      >
        {{ saveToLibraryStatus.saveError }}
      </alert>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import { ACTION_TYPES, CONTENT_TYPES, actionPermissions } from '@/util/access_visibility'
import { toolkitUrls } from '@/links'

import SaveToLibraryButton from '@/components/goals/SaveToLibraryButton'

export default {
  name: 'StrategySaveToLibraryPanel',
  components: {
    SaveToLibraryButton,
  },
  props: {
    strategyUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      saveToLibraryStatus: {
        checking: false,
        saving: false,
        saved: false,
        savedStrategyUuid: '',
        savedStudentName: '',
        saveError: '',
      },
    }
  },
  computed: {
    ...mapState('user', { userUuid: (state) => state.user.uuid }),
    ...mapGetters('user', ['authInfo']),
    ...mapGetters('visibility', ['betaVisibility']),
    savedStrategyUrl() {
      return toolkitUrls.libraryStrategyPage(this.saveToLibraryStatus.savedStrategyUuid)
    },
    actionPermissions() {
      return {
        save: actionPermissions(ACTION_TYPES.SAVE, CONTENT_TYPES.STRATEGY, {}, this.authInfo),
      }
    },
  },
  methods: {
    setSaveStatus(newStatusFlags) {
      this.saveToLibraryStatus = Object.assign({}, this.saveToLibraryStatus, newStatusFlags)
    },
    handleSaveError(errorMessage) {
      this.setSaveStatus({ saving: false, saveError: errorMessage })
    },
    handleSaveSuccess(successPayload) {
      this.setSaveStatus({
        saving: false,
        savedStrategyUuid: successPayload.uuid,
        savedStudentName: successPayload.student_name,
      })
    },
  },
}
</script>

<style>
.library-panel {
  background: #f5f5f5;
  border-radius: 3px;
  padding: 15px;
}

.action-alert {
  margin-top: 8px;
  margin-bottom: 0px;
}
</style>
